import * as d3 from 'd3-fetch'

const formatNflResults = function (valueRange) {
    const values = valueRange.values
    const columns = values[0]
    const results = values
        .slice(1)
        .map(d => {
            let obj = {}
            columns.forEach((c, i) => {
                obj[c] = d[i]
            })
            return obj
        })
    const resultsObj = results.reduce((obj, res) => {
        if (!(res.week in obj)) obj[res.week] = {}
        let { week, state } = res
        obj[res.week][res.team] = {
            week, state
        }
        return obj
    }, {})
    return resultsObj
}

const addResultsToPicks = function (nflResults, disPicks) {
    const combined = disPicks.slice(1).map(d => {
        const username = d[0]
        const picks = d.slice(1).map((p, i) => {
            return {
                team: p,
                ...nflResults[i + 1][p]
            }
        })
        const lives = picks.reduce((a, c) => {
            if (a === 0) return 0
            if (c.state === 'loss') return a - 1
            return a
        }, 2)
        const eliminated = lives <= 0
        return { username, picks, eliminated, lives }
    })

    return combined
} 

const fetchData = async function () {
    const url = "https://sheets.googleapis.com/v4/spreadsheets/19eitBp1kaPeB2L_2kJCJfIWpDC6k7SQBQvnhzzsOgYo/values:batchGet?ranges='NFL Results'!A1:E&ranges='Picks'!A1:S&majorDimension=ROWS&valueRenderOption=UNFORMATTED_VALUE&key=AIzaSyCXRuxAs8kBfcwXEibhQ3MnF_9lf6k7Dnc"
    const json = await d3.json(url)
    const nflResults = formatNflResults(json.valueRanges[0])
    const disPicks = json.valueRanges[1].values
    const data = addResultsToPicks(nflResults, disPicks)
    return data.sort((a, b) => b.lives - a.lives || b.picks.length - a.picks.length)
}

export { fetchData }